import React from 'react';
import ErrorMessage from './ErrorMessage';

/**
 * 错误边界组件 - 捕获子组件树中的JavaScript错误
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 记录错误到错误报告服务
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      // 自定义降级后的 UI
      return (
        <div style={{ padding: '40px 20px' }}>
          <ErrorMessage 
            message="抱歉，页面出现了错误。请刷新页面重试。"
            onRetry={() => window.location.reload()}
            type="error"
          />
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '20px', padding: '10px', background: '#f8f9fa', borderRadius: '4px' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>错误详情（仅开发环境显示）</summary>
              <pre style={{ marginTop: '10px', fontSize: '0.85rem', overflow: 'auto' }}>
                {this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
